import { graphqlClient } from "../../../client";
import getWalletDocument from "./getWalletQuery.graphql";
import type { WalletType } from "../../types";

export interface GetWalletQueryVariables {
  customerId: string;
}

export interface GetWalletQueryResult {
  wallet: WalletType | null;
}

export async function getWallet(payload: GetWalletQueryVariables): Promise<WalletType | null> {
  const { data } = await graphqlClient.query<GetWalletQueryResult, GetWalletQueryVariables>({
    query: getWalletDocument,
    variables: payload,
  });

  return data?.wallet ?? null;
}
